module.exports = __webpack_public_path__ + "img/chp-thought.d1b4f923.png";